import React, { Dispatch, SetStateAction, createContext, useState } from 'react'

interface FunnelContentProminenceBannerProps {
  showProminenceBanner: boolean
  setShowProminenceBanner: Dispatch<SetStateAction<boolean>>
  prominenceBannerAnimated: boolean
  setProminenceBannerAnimated: Dispatch<SetStateAction<boolean>>
}

export type FunnelContentContextProps = FunnelContentProminenceBannerProps

export const FunnelContentContext = createContext<FunnelContentContextProps>(null)

export const FunnelContentProvider = ({ children }: { children: React.ReactNode }) => {
  const [showProminenceBanner, setShowProminenceBanner] = useState(true)
  const [prominenceBannerAnimated, setProminenceBannerAnimated] = useState(false)

  return (
    <FunnelContentContext.Provider
      value={{
        showProminenceBanner,
        setShowProminenceBanner,
        prominenceBannerAnimated,
        setProminenceBannerAnimated,
      }}
    >
      {children}
    </FunnelContentContext.Provider>
  )
}
